//  @flow
import { pickBy } from 'lodash'

export default (state: Object, resources?: Object): { ... } => {
  const resourcesMeta = pickBy(state.meta, (resourceMeta) => resourceMeta.preUpdated)
  return pickBy(resources || state.resources, (resource, id: string) => resourcesMeta[id])
}
